interface OrderStatusUrlParams {
  siteSlug: string
  orderId: string
  statusToken: string
}

/** An order's status page. The token travels as a query string; Ziggy appends any param the route does not name. */
export const orderStatusUrl = ({ siteSlug, orderId, statusToken }: OrderStatusUrlParams): string =>
  route('pjazza.order-status', { site: siteSlug, order: orderId, token: statusToken })
